import React, { Component } from "react";
import Slider from "react-slick";
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import InnerImageZoom from 'react-inner-image-zoom';

export default class AsNavFor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
        };

    }
    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
        });
    }


    render() {
        return (
            <>
                <Slider
                    asNavFor={this.state.nav2}
                    ref={(slider) => (this.slider1 = slider)}
                    className="slick-for"
                >
                    {this.props.productImages?.map((item, index) => (
                        <div key={index} className="slide-item">
                            <InnerImageZoom src={item.image} zoomSrc={item.image} />
                        </div>
                    ))}
                </Slider>
                <Slider
                    asNavFor={this.state.nav1}
                    ref={(slider) => (this.slider2 = slider)}
                    slidesToShow={3}
                    swipeToSlide={true}
                    focusOnSelect={true}
                    className="slick-nav"
                    infinite={false}
                    responsive={
                        [{
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        }]
                    }
                >
                    {this.props.productImages?.map((item, index) => (
                        <div key={index}>
                            <img src={item.image} />
                        </div>
                    ))}
                </Slider>
            </>
        );
    }
}
